export default {
  title: {
    action: {
      create: "toevoegen",
      update: "bewerken",
    },
  },
  button: {
    save: "Opslaan",
    search: "Zoeken",
    cancel: "Annuleren",
  },
}
